<template>
    <div class="pchomebox">
        <div  v-if="istoptab" class="tablogo">
           <h1 class="logo"></h1> 
            <div class="btns">
             <button class="regbtn" @click="goRecharge()">Recharge</button>
              <button  @click="openquery()"   class="facebookbtn">FB account query</button> 
              <a href="https://apps.apple.com/id/app/id1517789247"><button class="appicon"></button></a>
              <a href="https://play.google.com/store/apps/details?id=com.wheat.mango"><button class="googleicon"></button></a>
              <a href="https://mango-file.oss-ap-southeast-1.aliyuncs.com/mango_of.apk"><button class="downloadicon"></button></a>
            </div>
      </div>
        <div class="topbox">
           <div class="logobtns">
             <h1 class="logo"></h1> 
             <div> 
                 <button class="regbtn" @click="$router.push('/aboutus')">About Us</button> 
                 <button class="regbtn" @click="$router.push('/becomeagency')">Agency</button> 
                 <button class="regbtn" @click="goRecharge()">Recharge</button> 
                  <button  @click="openquery()"   class="facebookbtn">FB account query</button>
             </div>
            
        
            </div> 
             <div class="socialsbox">
               <div class="socials">
               <h4 class="title1"></h4> 
                  <a href="https://apps.apple.com/id/app/id1517789247"><button class="appstore"></button></a>
                  <!-- <a href="https://play.google.com/store/apps/details?id=com.wheat.mango"><button class="googlelpay"></button></a> -->
                  <a href="https://mango-file.oss-ap-southeast-1.aliyuncs.com/mango_of.apk"><button class="download"></button></a>
               </div>
       
             <img class="imgs img1" src="../../assets/images/liveimg/pic1@2x2.png" alt=""> 

             </div>

             <div class="pic2box">
               <div>
                 <h4 class="title2"></h4> 
                <p class="title2_txt">Dancers, singers & surprises!<br> Watch and participate in broadcasting lives.</p>
               </div>
               <img class="imgs img2" src="../../assets/images/liveimg/pic2@2x.png" alt=""> 
              
             </div>
              
              <div class="pic3box">
               <img class="imgs img3" src="../../assets/images/liveimg/pic3@2x.png" alt=""> 
               <div>
                <h4 class="title3"></h4> 
                <p class="title3_txt">Lovely, romantic, funny gifts</p>
                </div>
   
              </div>
           
        </div> 
        <div class="footer">
            <p class="title">Follow Us On</p>
            <div class="icons">
               <a class="icon1" href=" https://www.facebook.com/Mango-live-Indonesia-110210587385704/"></a>
               <a class="icon2" href="https://www.instagram.com/mangolive.tv/"></a>               
               <a class="icon3" href=" https://twitter.com/MangoLive6"></a>
            </div>
            <div class="txtp">
              <p @click="gopage('agreement')"  class="txtline">Agreement</p>
              <p @click="gopage('privacy')"  class="txtline">Privacy</p>
              <p @click="gopage('aboutus')"  class="txtline">About Us</p>
              <p @click="gopage('community')" class="txtline">Community Rules</p>
              <p @click="gopage('becomeagency')" class="txtline">Become Agency</p>
              <p @click="gopage('broadcasters')"  class="txtline">Host Violation Regulation</p>
              <p  class="txtline"><a href="./review.html">Layanan Pengaduan Konsumen</a></p>
            </div>

            <p class="Copyright">Copyright 2019-{{year}} APPXYZ MOBILE COMPANY LIMITED. All Rights Reserved.</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
     return{
        istoptab:false,
        queryinput:'',
     }
    },
    created(){
       this.queryinput =   this.$route.query.code
        console.log(this.queryinput)
        if(this.queryinput){
         this.openquery()
        }
    },
    computed:{
      year(){
        return new Date().getFullYear()
      }
    },
    methods:{
     gopage(page){
       this.$router.push({name:page})    
     },
     handleScroll() {//获取滚动时的高度
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 
        // console.log(scrollTop)
        if (scrollTop < 50) {
          this.istoptab = false
        }
        if (scrollTop > 0) {
           this.istoptab = true
        }
     },
     openquery(){
       var _this = this
            _this.$prompt('Enter Your Facebook UserID', 'Facebook Authorization Information Inquire', {
          confirmButtonText: 'Check',
          showCancelButton:false,
          inputValue:_this.queryinput,
          customClass:'BOXclass'
          }).then(({ value }) => {
            console.log(value)
            if(value == null || !value){
               this.$message.error('Enter Your Facebook UserID');
               return 
            }
            _this.$http.get(_this.$api.trackDeletion,{params:{confirmationCode:value}}).then(function (response) {      
                    console.log(response)
                    var tape ="warning"
                    var txt ="Unauthorized"
              if(response.data.msg =="AUTHORIZED"){
                       tape ="success"
                       txt ="Authorized"  
                }else if(response.data.msg =="UNAUTHORIZED"){
                    tape ="warning"
                     txt ="Unauthorized"
                }else if(response.data.msg =="UNBUNDLING"){
                    tape ="error"
                     txt ="Deleted"
                 }else{
                  tape ="error"
                     txt =response.data.msg
                 }
         // success  Authorized / warning Unauthorized / error Deleted
       _this.$confirm(txt, '', {  confirmButtonText: 'ok',    showCancelButton:false,
                     customClass:'pcokclass',   type: tape,    }).then(() => {  })  })   })
 
     },
       goRecharge(){
        this.$router.push({path:'/recharge'})
       },

    },
 
    mounted(){
          window.addEventListener("scroll",this.handleScroll); 
        // new Swiper('.swiper-container',{})
    },
    destroyed() {
      document.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped lang="less">
   .topbox{
     width: 100%;height: 100%; background:  url('../../assets/images/liveimg/bg_web.png');
     background-size: 100% 100%;
   }
  .tablogo{
       width: 100%; height: .42rem; display: flex; top: 0;
      padding: 0 .5rem 0 1rem; box-sizing: border-box;position: fixed;z-index: 999;
      justify-content: space-between; align-items: center; background: #ffff;
       animation: txtimg 1s;opacity:1;
     .logo{
          width:1.1rem; height: .2rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     }
     .btns{
       display: flex;
         .appicon{
            width:.21rem; height: .21rem;
            background:  url('../../assets/images/liveimg/appstore_top@2x.png');
            background-size: 100% 100%; margin-right: .05rem;
         }
         .googleicon{
            width:.21rem; height: .21rem;
            background:  url('../../assets/images/liveimg/googleplay_top@2x.png');
            background-size: 100% 100%; margin-right: .05rem;
         }
         .downloadicon{
            width:.21rem; height: .21rem;
            background:  url('../../assets/images/liveimg/download_top@2x.png');
            background-size: 100% 100%; 
         }
           button:hover{
            opacity: .8;
          }
     }
     .regbtn{
         padding: 0 .07rem;height:0.21rem; line-height: .21rem; font-size:0.09rem;
        background:linear-gradient(270deg,rgba(92,46,232,1),rgba(202,90,245,1));
        border-radius:1rem;  color:rgba(255,255,255,1);margin-left: 0.1rem;
     }
     .facebookbtn{
      margin-left: .1rem;   margin-right: .1rem;  height:0.21rem;font-size:0.09rem;padding: 0 .07rem;
     border-radius:1rem;  color: #fff; 
  background:linear-gradient(270deg,rgba(92,46,232,1),rgba(202,90,245,1));
}
  .regbtn:active, .facebookbtn:active{
    transform: scale(.9);
    
}
  }
      @keyframes txtimg {  
        0%,to{opacity:0; top: -888px;}100%{opacity:1;top: 0;  }
            }   
  .logobtns{
      width: 100%; height: .42rem; display: flex; 
      padding: 0 .5rem 0 1rem; box-sizing: border-box;
      justify-content: space-between; align-items: center;
     .logo{
     width:1.1rem; height: .2rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     }
     .regbtn{
         padding: 0 .07rem;height:0.21rem; line-height: .21rem; font-size:0.09rem;
        background:linear-gradient(270deg,rgba(92,46,232,1),rgba(202,90,245,1));
        border-radius:1rem;  color:rgba(255,255,255,1);margin-left: 0.1rem;
     }
     .facebookbtn{
      margin-left: .1rem;    height:0.21rem;font-size:0.09rem;padding: 0 .07rem;
     border-radius:1rem;  color: #fff; 
  background:linear-gradient(270deg,rgba(92,46,232,1),rgba(202,90,245,1));
}
  .regbtn:active, .facebookbtn:active{
    transform: scale(.9);
    
}
  
  }
  .socialsbox{
    position: relative; width: 5.6rem; margin: 0 auto;margin-top: .43rem;
        .img1{
        width: 2.8rem;  
        position: absolute;right:.3rem ; top: 0;
     }
  }
  .socials{
    display: flex; flex-direction: column;
     width:2.56rem;

    .title1{
        width:2.56rem; height: 0.5rem;margin: .6rem 0 .37rem 0;
        background:url('../../assets/images/liveimg/Beautypc@2x.png');  background-size: 100% 100%;
    }
    button{
     width: 1.46rem; height: .38rem;   
     margin-bottom: .21rem;
    }
    button:hover{
      opacity: .8;
    }
    .appstore{
         background:url('../../assets/images/liveimg/AppStore_phone@2x.png');
        background-size: 100% 100%;
    }
    .download{
      background:url('../../assets/images/liveimg/Download_phone@2x.png');
        background-size: 100% 100%;
    }
    .googlelpay{
      background:url('../../assets/images/liveimg/GooglePlay_phone@2x.png');
        background-size: 100% 100%;
    }
     

  }
    .pic2box{
       width: 5.6rem; margin: 0 auto;margin-top: 1.45rem;
       height:4rem ;  display: flex; align-items: center; 
        .img2{
        width: 3.08rem; height:4rem ;  
      
     } 
    }
    .pic3box{
       width: 5.6rem; margin: 0 auto;margin-top: .77rem;
        display: flex; align-items: center; 
        .img3{
        width:4.11rem; height: 4.7rem;
       
     } 
         .title3{
          width: 2.26rem; height:.5rem ; margin-bottom: .21rem;
        background:url('../../assets/images/liveimg/ImpressGiftspc@2x.png');
        background-size: 100% 100%;    
     }
    }
 
    //  .img2{
    //     width: 7.78rem; height:9.95rem ; margin-top: 1.56rem;
    //  }
     .title2{
        width:2.43rem; height: .17rem;margin-bottom: .21rem;
        background:url('../../assets/images/liveimg/Meettalents.@2x.png');
        background-size: 100% 100%; 
     }
     .title3_txt , .title2_txt{
       width: 100%;    text-align: left;font-size:0.11rem;color:rgba(48,48,48,1);
     }
 
     .footer{
      width:100%;  height:2.09rem; display: flex; flex-direction: column;
        background:rgba(0,0,0,1);   align-items: center; color: #fff; justify-content: space-between;
         font-size:0.1rem; padding: .3rem 0; box-sizing: border-box;
        .icons{
           display: flex;width: 100%; justify-content: center; margin-top: .16rem;

          .icon1{
            width:.32rem; height: .32rem;
            background:url('../../assets/images/liveimg/facebook_phone@2x.png');
            background-size: 100% 100%;    margin-right: .27rem; 
          } 
          .icon2{
            width:.32rem; height: .32rem;
            background:url('../../assets/images/liveimg/instagram_phone@2x.png');
            background-size: 100% 100%;     margin-right: .27rem;
          } 
          .icon3{
            width:.32rem; height: .32rem;
            background:url('../../assets/images/liveimg/twitter_phone@2x.png');
            background-size: 100% 100%;    
          } 
        }
        .txtp{
         display: flex; width: 100%; justify-content: center;  margin-top: .32rem;
          p{  font-size:0.1rem; margin-right: .4rem;}
        }
       
       .txtline{
           text-decoration:underline; cursor:pointer ;
           a{
            color: #fff;
           }
       }
       .Copyright{
          color:rgba(160,160,160,1);  margin-top: .4rem;
       }
     }

</style>




// WEBPACK FOOTER //
// src/page/webpage/pchome.vue